import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "fullwidth"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "page-content" }
const _hoisted_5 = { class: "width-wrap" }
const _hoisted_6 = { class: "page-navbar" }
const _hoisted_7 = { class: "nav-tabs" }
const _hoisted_8 = ["href", "onClick"]
const _hoisted_9 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Registration.title')), 1),
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('Registration.has-account')) + " ", 1),
          _createVNode(_component_LoginButton)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("nav", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'RegistrationAgent' } }, {
                default: _withCtx(({ href, navigate, isExactActive }) => [
                  _createElementVNode("li", {
                    class: _normalizeClass([isExactActive && 'is-active'])
                  }, [
                    _createElementVNode("a", {
                      href: href,
                      onClick: navigate
                    }, _toDisplayString(_ctx.$t('Registration.agent')), 9, _hoisted_8)
                  ], 2)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: { name: 'Registration' } }, {
                default: _withCtx(({ href, navigate, isExactActive }) => [
                  _createElementVNode("li", {
                    class: _normalizeClass([isExactActive && 'is-active'])
                  }, [
                    _createElementVNode("a", {
                      href: href,
                      onClick: navigate
                    }, _toDisplayString(_ctx.$t('Registration.person')), 9, _hoisted_9)
                  ], 2)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createVNode(_component_router_view)
    ])
  ]))
}